// extracted by mini-css-extract-plugin
export default {"paymentSection":"y7-z"};